import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar
} from "@material-ui/core";


import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService} from "./../../utils/web_config_2";

import UserInfo from "./login_info";

import axios from 'axios';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
}));


 function Fines() {
  const classes = useStyles1();

  
  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [fineMessage,setFineMessage]=useState("Loading...");


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//offenses table 


const columns = [
  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "driver_name",
   label: "Driver Name",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "offender",
   label: "Offender",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "totalAmount",
   label: "Amount",
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "plate_number",
    label: "Plate Number",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "vehicle_type",
    label: "Vehicle Type",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "createdAt",
    label: "Date Time",
    options: {
     filter: true,
     sort: false,
    }
   }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: fineMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View offenses" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 get_offenses(id);
}} />
      </Box>
  ),
 };


 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
  axios.defaults.baseURL = new TransportService().BASE_URL;

  get_fines(data.token);

 },[]);


 // get fines
const [fineLoad,setFineLoad]=useState(false);
 const [fines,setFines]=useState([]);
 const get_fines=(token)=>{
  setFineMessage("Laoding...");
   setFineLoad(true);
   const fineInstance = axios.create(new TransportService().setHeaders(token));
   fineInstance.get('/api/v1/fines/getAllFineTicketsByOperator/'+new UserInfo().ID)
   .then(res=>{
     var objs=res.data;
     objs.map((o)=>{
       o['driver_name']=o.driver!=null?o.driver.first_name+" "+o.driver.last_name:"null";
       o['plate_number']=o.vehicle!=null?o.vehicle.number_plate:"null";
       o['vehicle_type']=o.vehicle!=null?o.vehicle.v_type:"null";
     });
     setFineLoad(false);
     setFines(res.data);
   }).catch(err=>{
     setFineLoad(false);
    enqueueSnackbar(err.message,
      { 
        variant: 'error'
    });
   });
   
 }


 // offense dialog 
 const [offenseDialog,setOffenseDialog]=useState(false);
 // get offense 
 const [offenses,setOffenses]=useState([]);
 const get_offenses=(id)=>{
   var of=fines.find((o)=>o.id==id);
   setOffenses(of['offences']);
   setOffenseDialog(true);
 }

  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><AllInclusive fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Fines</b></Typography>

 </Box>
 

</Box>


<Box mt={2}>
  {fineLoad&&<LinearProgress/>}
<MUIDataTable
  title={"Fines list"}
  data={fines}
  columns={columns}
  options={options}
/>
</Box> 


{/* offense dialog  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={offenseDialog}
        onClose={()=>{
          setOffenseDialog(false);
        }}
        aria-labelledby="fines"
        aria-describedby="fines"
      >
        <DialogTitle id="fines">{"Fines"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <List>
            {offenses.map((o)=>{
              return  <ListItem>
              <ListItemAvatar>
                  <Gavel/>
              </ListItemAvatar>
              <ListItemText primary={o['offense']['name']} secondary={o['amount']} />
            </ListItem>;
            })}
     
      
    </List>
        
          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
             setOffenseDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


        </DialogActions>
         </Dialog>


 </div>
  );
}

export default withLocalize(Fines)